/** Tokens visuais — campanhas / broadcast (marca TNV) */
export const COMUNICADO_ACCENT = "#F96030";
export const COMUNICADO_ACCENT_SOFT = "rgba(249, 96, 48, 0.08)";
export const COMUNICADO_INK = "#1a2035";
export const COMUNICADO_MUTED = "#67748e";

export const composerPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
};

export const composerHeaderSx = {
  px: { xs: 1.5, md: 2 },
  py: { xs: 1, md: 1.25 },
  flexShrink: 0,
  background: `linear-gradient(135deg, ${COMUNICADO_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `2px solid ${COMUNICADO_ACCENT}`,
};

export const sectionCardSx = {
  p: 2.5,
  borderRadius: 2,
  border: "1px solid",
  borderColor: "grey.200",
  bgcolor: "background.paper",
};

export const sectionCardResponsiveSx = {
  ...sectionCardSx,
  p: { xs: 1.5, sm: 2, md: 2.5 },
};

export const composerContentSx = {
  p: { xs: 2, sm: 2.5, md: 3 },
  flex: 1,
  minHeight: 0,
  overflow: "auto",
};
